import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import CardBack from '../../tarot-components/CardBack'
import { cardImage, track } from './landingUtils'

// The card the hero turns over. XVII, The Star: hope and renewal, the card
// you would want to be greeted with.
const HERO_CARD = 'the_star.jpg'

// Engraved astrolabe. The tick ring is a single circle whose dash pattern
// walks the circumference, so 60 marks cost one element instead of 60.
const Astrolabe = () => (
    <svg
        className="arcana__astrolabe"
        viewBox="0 0 600 600"
        fill="none"
        stroke="currentColor"
        aria-hidden="true"
        focusable="false"
    >
        <circle cx="300" cy="300" r="292" strokeWidth="1" />
        <circle cx="300" cy="300" r="256" strokeWidth="1" />
        <circle cx="300" cy="300" r="242" strokeWidth="11" strokeDasharray="1.5 23.8" />
        <circle cx="300" cy="300" r="196" strokeWidth="1" />
        <circle cx="300" cy="300" r="170" strokeWidth="1" />
        <circle cx="300" cy="300" r="74" strokeWidth="1" />
        <polygon points="300,130 447.2,385 152.8,385" strokeWidth="1" />
        <polygon points="300,470 152.8,215 447.2,215" strokeWidth="1" />
    </svg>
)

/**
 * Three cards dealt onto the table; the middle one turns over. Pure CSS:
 * each card deals in on a stagger, then the centre card flips once.
 */
const HeroFan = () => {
    const { t } = useTranslation()
    const star = cardImage(HERO_CARD, '(max-width: 560px) 42vw, 230px')

    return (
        <div className="hero-fan" role="img" aria-label={t('public.hero.fanLabel')}>
            <div className="hero-fan__glow" aria-hidden="true" />
            <div className="hero-fan__card hero-fan__card--left" aria-hidden="true">
                <CardBack />
            </div>
            <div className="hero-fan__card hero-fan__card--right" aria-hidden="true">
                <CardBack />
            </div>
            <div className="hero-fan__card hero-fan__card--center" aria-hidden="true">
                <div className="flip">
                    <div className="flip__face flip__face--back">
                        <CardBack />
                    </div>
                    <div className="flip__face flip__face--front">
                        <img
                            {...star}
                            alt=""
                            width="320"
                            height="533"
                            decoding="async"
                            fetchpriority="high"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Hero = () => {
    const { t } = useTranslation()
    const reassurance = t('public.hero.reassurance', { returnObjects: true })

    return (
        <section className="arcana-hero">
            <div className="arcana__veil" aria-hidden="true">
                <Astrolabe />
            </div>

            <div className="arcana-hero__inner arcana__inner">
                <div className="arcana-hero__copy">
                    <p className="arcana__eyebrow">{t('public.hero.eyebrow')}</p>
                    <h1 className="arcana__title">
                        <Trans i18nKey="public.hero.title" components={{ br: <br />, em: <em /> }} />
                    </h1>
                    <p className="arcana__lead">{t('public.hero.lead')}</p>

                    <div className="arcana__actions">
                        <Link
                            to="/register"
                            className="arcana-btn"
                            onClick={() => track('cta_click', { where: 'hero' })}
                        >
                            {t('public.hero.cta')}
                            <span className="arcana-btn__arrow" aria-hidden="true">&#8594;</span>
                        </Link>
                        <Link to="/login" className="arcana__link">
                            {t('public.hero.signIn')}
                        </Link>
                    </div>

                    {Array.isArray(reassurance) && (
                        <ul className="arcana-hero__trust">
                            {reassurance.map((item) => <li key={item}>{item}</li>)}
                        </ul>
                    )}
                </div>

                <HeroFan />
            </div>
        </section>
    )
}

export default Hero
